module.exports = __webpack_public_path__ + "img/odwh3_v2_element_03.043f1e76.png";